import React from 'react';
import SentBudgetsTable from './SentBudgetsTable';
import GroupedBudgetsTable from './GroupedBudgetsTable';
import Filters from './Filters';
import { getAgentBudgets, getAgentNetwork } from './agentBudgets';

const PAGE_SIZE = 50;

class SentBudgets extends React.Component {
  constructor(props) {
    super(props);

    const agentId = props.agentId;
    if (!agentId) {
      alert(
        'Identificación de correduría no válida. No se cargarán ni enviarán presupuestos.'
      );
      this.state = { rows: [], loading: false };
    } else {
      this.state = {
        rows: [],
        loading: true,
        page: PAGE_SIZE,
        agentId,
        agentNetwork: {},
        showGroupTable: false,
      };
      this.loadAgentNetwork();
      this.loadAgentDrafts(PAGE_SIZE);
    }
  }

  loadAgentDrafts = async (count, filterValues) => {
    try {
      if (this.state.agentId) {
        const data = await getAgentBudgets({
          agentId: this.state.agentId,
          agentNetwork: this.state.agentNetwork,
          top: count,
          ...filterValues,
        });

        const showMore = data.length >= count;
        let filterByGroup = false;
        if (filterValues) {
          filterByGroup =
            filterValues.groupAgent ||
            filterValues.groupProduct ||
            filterValues.groupStatus;
        }

        this.setState({
          rows: data,
          loading: false,
          isLoadingMore: false,
          page: count,
          showMore: showMore,
          showGroupTable: filterByGroup,
        });
      }
    } catch (error) {
      this.setState({ loading: false, isLoadingMore: false });
      alert('Se ha producido un error al cargar los presupuestos.');
      console.error(error);
    }
  };

  loadAgentNetwork = async () => {
    try {
      if (this.state.agentId) {
        const agentNetwork = await getAgentNetwork(this.state.agentId);

        this.setState({ agentNetwork });
      }
    } catch (error) {
      this.setState({ loading: false });
      alert('Se ha producido un error al cargar los agentes.');
      console.error(error);
    }
  };

  filterAgentDrafts = (filters) => {
    this.setState({ filters, loading: true });
    this.loadAgentDrafts(PAGE_SIZE, filters);
  };

  onLoadMore = () => {
    this.setState({ isLoadingMore: true });
    this.loadAgentDrafts(this.state.page + PAGE_SIZE, this.state.filters);
  };

  render() {
    return (
      <div
        style={{ minHeight: '440px' }}
        className="section o-section o-section--large"
      >
        <div className="container-fluid">
          <div className="inner-small-container">
            <Filters
              onFilter={this.filterAgentDrafts}
              agentNetwork={this.state.agentNetwork}
            />
            {this.state.showGroupTable ? (
              <GroupedBudgetsTable
                {...this.state}
                showMore={this.state.showMore}
                onLoadMore={this.onLoadMore}
                onShowDraftDoc={this.showDraftDoc}
              />
            ) : (
              <SentBudgetsTable
                {...this.state}
                showMore={this.state.showMore}
                onLoadMore={this.onLoadMore}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SentBudgets;



// WEBPACK FOOTER //
// ./src/components/SentBudgets/index.js